/* eslint-disable react/no-multi-comp */
import { buildIntrinsicWidthSources } from '@velasca/utils/build-intrinsic-width-sources'
import { setQueryParams } from '@velasca/utils/set-query-params'
import { SquareVideo } from '../SquareVideo/SquareVideo'
import { BlocksGrid, StyledResponsiveImage } from './Layout4.styles'
import type { GridProps, ItemProps } from './Layout4.types'

export const Grid = ({ handle, children }: GridProps): JSX.Element => {
  return <BlocksGrid id={handle}>{children}</BlocksGrid>
}

export const Item = ({ media }: ItemProps): JSX.Element | null => {
  if (!media) {
    return null
  }

  if (media.type === 'image') {
    return (
      <StyledResponsiveImage
        lqip
        lazyload
        alt={media.alt}
        sources={buildIntrinsicWidthSources({ src: media.src })}
        imgSrc={setQueryParams(media.src, [{ name: 'width', value: '30' }])}
      />
    )
  }

  return <SquareVideo poster={media.preview} sources={media.sources} />
}
